export default {
    createMultipleLogs: "/logger/createMultipleLogs",
    getTimetableLogs: "/logger/timetable/get",
    getLectureLogs: "/logger/lecture/get",
    getFacultyAllocationLogs: "/logger/facultyAllocation/get",
    createLogForSingleUser: "/logger/semesterUser/createLogForSingleUser",
    createLogsForMultipleUsers: "/logger/semesterUser/createLogsForMultipleUsers",
    getSemesterUserLogs: "/logger/semesterUser/get",
    getStudentCourseAllocationLogs: "/logger/studentCourseAllocation/get"
}